import { Injectable } from '@angular/core';
import { NetworkService } from '@spreadmonitor/network';
import { format } from 'date-fns';
import { from, Observable } from 'rxjs';
import { map, pluck, switchMap } from 'rxjs/operators';
import { ApiResponse } from '../../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  constructor(private readonly network: NetworkService) {}

  public listAttachmentsForContract(contractId: number) {
    // TODO: Add proper typing
    return this.network
      .get<ApiResponse<{ fileName: string; id: number }[]>>(`/v1/contracts/${contractId}/attachments`)
      .pipe(pluck('payload'));
  }

  public getAttachment(attachmentId: number) {
    // TODO: Add proper typing
    return this.network
      .get<ApiResponse<{ fileName: string; downloadUrl: string }>>(`/v1/attachments/${attachmentId}`)
      .pipe(pluck('payload'));
  }

  public uploadAttachment(contractId: number, fileName: string, blob: Blob) {
    // TODO: Add proper typing
    return this.network
      .post<ApiResponse<{ fileName: string; uploadUrl: string; id: number }>>(`/v1/attachments`, { fileName })
      .pipe(
        pluck('payload'),
        switchMap(attachment =>
          from(
            fetch(attachment.uploadUrl, {
              method: 'PUT',
              body: blob,
              headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-ms-blob-type': 'BlockBlob',
              },
            })
          ).pipe(map(() => attachment))
        ),
        switchMap(attachment =>
          // Add attachment for contract
          this.network.post<void>(`/v1/contracts/${contractId}/attachments`, { attachmentId: attachment.id }).pipe(
            pluck('payload'),
            map(() => attachment)
          )
        )
      );
  }

  public generateAttachments(contractId: number, date: Date): Observable<void> {
    return this.network.post<void>(`/v1/contracts/${contractId}/generate-assets`, {
      dateOfGeneration: format(date, 'yyyy-MM-dd'),
    });
  }
}
